import React from 'react';
import { SupportedLocale, SupportedRegion } from 'types/Supported';

const LocalizationContext = React.createContext<{ locale: SupportedLocale; region: SupportedRegion }>({
  locale: 'cs',
  region: 'cesko',
});

export default LocalizationContext;
